// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","110":"fe51fb575cf2e30de433","195":"128be39e1d8f6e4c864a","243":"307c1cf31df043fbcfea","556":"56a775be0f227ee032f2","595":"f7776ac79a7da92f941a"}[chunkId] + ".bundle.js";
};